<template>
    <div>
        <modal class="import-meter-record" :closeType="closeType" :display="open" @modalStatus="closeModal" >
            <h1>{{type==='ELECTRICITY'?'電費':type==='WATER'?'水費':type==='GAS'?'瓦斯費':''}}：房客拍表紀錄</h1>
            <div class="import-meter-record-wrap">
                <div class="content">
                    <div v-if="isMeterRecordBlock" class="default-wrap meter-record-block h-align">
                        <div v-if="!meterRecordObj.checkInMeter" class="prev-record h-align">
                            入住點交度數
                            <div class="amount no-result">
                                無
                            </div>
                        </div>
                        <div v-else-if="lastTimeRecord" class="prev-record h-align">
                            前次紀錄度數
                            <div class="amount">
                                {{lastTimeRecord}}
                            </div>
                        </div>
                        <div v-else-if="meterRecordObj.checkInMeter" class="prev-record h-align">
                            入住點交度數
                            <div class="amount">
                                {{meterRecordObj.checkInMeter}}
                            </div>
                        </div>
                        <div  v-if="meterRecordObj.type && meterRecordObj.type.billChargeType === 'BY_KILOWATT' && meterRecordObj.amountByMeter" class="meter h-align">
                            一度{{type === 'ELECTRICITY'?'電':type === 'WATER'?'水':type === 'GAS'?'瓦斯':''}}
                            <div class="amount">
                                {{meterRecordObj.amountByMeter}} 元
                            </div>
                        </div>
                    </div>
                    <div  v-if="meterRecordObj.utilityMeterList.length" class="list h-align">
                        <div class="item" v-for="(item, index) in meterRecordObj.utilityMeterList" :key="index">
                            <div class="image">
                                <img class="meter-image" :src="imageUrl(item.photoUrl)" alt="">
                            </div>
                            <div class="item-meter h-align">
                                <img v-if="type === 'ELECTRICITY'" src="@/assets/img/component/meterRecord/electrict.svg" alt="">
                                <img v-if="type === 'WATER'" src="@/assets/img/component/meterRecord/water.svg" alt="">
                                <img v-if="type === 'GAS'" src="@/assets/img/component/meterRecord/gas.svg" alt="">
                                {{item.meter}}度
                                <checkbox-single v-if="meterRecordObj.type && meterRecordObj.type.billChargeType === 'BY_KILOWATT'" v-model="selected" :val="index" :isPropChecked="selected === index"></checkbox-single>
                            </div>
                            <div class="group  h-align">
                                <div class="date">
                                    {{getFormatDateTime(item.createdDate)}}
                                </div>
                                <div v-if="item.status === 'DISABLE'" class="status gray">
                                    房客刪除
                                </div>
                                <div v-if="index === 0 && item.addInBill" class="status blue">
                                    前次紀錄度數
                                </div>
                                <div v-else-if="isAddInBill!=null && index === isAddInBill" class="status blue">
                                    前次紀錄度數
                                </div>
                                <div v-else-if="index === 1 && isAddInBill == null && !meterRecordObj.utilityMeterList[0].addInBill" class="status blue">
                                    前次紀錄度數
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-result" v-else>
                        <img src="@//assets/img/icon/empty_list.svg" alt="">
                        <div>
                            尚無紀錄
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isImport" class="btn-group">
                <button class="default-button confirm" :disabled="selected == null" @click="importMeter">加入帳單</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import checkboxSingle from '@/components/bussiness/widges/input/checkboxSingle.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'
import { 
    getMeterRecord
} from "@/apis/company/meterRecord.js"; 
import { 
    getMeterRecord as getLandlordMeterRecord
} from "@/apis/landlord/meterRecord.js"; 

export default {
    data () {
        return {
            meterRecordObj: {},
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            selected: null
        }
    },
    created() {
        this.getMeterRecord()
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    props: {
        type: null,
        open: false,
        loginType: {
            type: String,
            default: 'COMPANY'
        },
        closeType: {
            type: String,
            default: 'CLOSE'
        },
        contractSeq: {
            type: String,
            default: null
        }
    },
    watch: {
        modalStatus: {
            handler: function (val) {
               
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getMeterRecord: function () {
            const data = {
                contractSeq: this.contractSeq?this.contractSeq:this.$route.query.contractSeq,
                type: this.type
            }
            // console.log(this.loginType)
            // console.log(data)
            if(this.loginType === 'COMPANY'){
                getMeterRecord(data)
                .then(res => {
                    // console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.meterRecordObj = res.data.result
                        if(this.meterRecordObj.type.amount!=null &&  this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT'){
                            this.$emit('billChargeMode', `每度 ${this.meterRecordObj.type.amount} 元`)
                        }else if(this.meterRecordObj.type.amount!=null && this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_MONTH'){
                            this.$emit('billChargeMode', `每月 ${this.meterRecordObj.type.amount} 元`)
                        }else if(this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'PAY_BY_SELF'){
                            this.$emit('billChargeMode', `依帳單繳交`)
                        }
                    }
                })
                .catch(err => {
                })
            }else if(this.loginType === 'LANDLORD'){
                getLandlordMeterRecord(data)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.meterRecordObj = res.data.result
                        if(this.meterRecordObj.type.amount!=null  && this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT'){
                            this.$emit('billChargeMode', `每度 ${this.meterRecordObj.type.amount} 元`)
                        }else if(this.meterRecordObj.type.amount!=null && this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_MONTH'){
                            this.$emit('billChargeMode', `每月 ${this.meterRecordObj.type.amount} 元`)
                        }else if(this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'PAY_BY_SELF'){
                            this.$emit('billChargeMode', `依帳單繳交`)
                        }
                    }
                })
                .catch(err => {
                })
            }
            
        },
        importMeter: function () {
            this.closeModal()
            this.$store.dispatch('setAlarmStatus', {status: true,title: '已添加至帳單',type: 'success',closeBtn: false})
            if(this.selected == null) return
            if(this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT' && !this.meterRecordObj.utilityMeterList.length || this.meterRecordObj.type.billChargeType === 'BY_KILOWATT' && this.meterRecordObj.utilityMeterList.length === this.selected+1){
                if(this.meterRecordObj.utilityMeterList[this.selected].addInBill){
                    this.$emit('input', 0)
                }else{
                    this.$emit('input', Math.round(this.meterRecordObj.type.amount*(this.meterRecordObj.utilityMeterList[this.selected].meter-this.meterRecordObj.checkInMeter)))
                }
            }else if(this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT'){
                if(this.meterRecordObj.utilityMeterList[this.selected].addInBill){
                    this.$emit('input', 0)
                }else{
                    this.$emit('input', Math.round(this.meterRecordObj.type.amount*(this.meterRecordObj.utilityMeterList[this.selected].meter-this.meterRecordObj.utilityMeterList[this.selected+1].meter)))
                }
            }
            this.$emit('meterCid', this.meterRecordObj.utilityMeterList[this.selected].cid);
        },
        resizeModal: function (){
            let _self = this
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-400) + 'px'
                _self.componentKey += 1
            }
        },
        closeModal: function () {
            this.$emit('closeModal')
            // this.$store.dispatch('setModalStatus', {state: false, type: 'bizImportMeterRecord'})
        },
        imageUrl: function (url){
            return constant.imageUrlNoCdn+url
        },
    },
    computed: {
        lastTimeRecord: function () {
            const list = this.meterRecordObj.utilityMeterList
            let record = 0
            if(!list.length){
                return record
            }else{
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(i === 0 && element.addInBill){
                        record = element.meter
                        break
                    }else if(this.isAddInBill!=null && i === this.isAddInBill){
                        record = element.meter
                        break
                    }else if(i === 1 && this.isAddInBill == null && !list[0].addInBill){
                        record = element.meter
                        break
                    }
                }
            }
            return record
        },
        isMeterRecordBlock: function () {
            if(!this.meterRecordObj.type) return
            if(this.meterRecordObj.type.billChargeType === 'PAY_BY_SELF' && !this.meterRecordObj.checkInMeter){
                return false
            }else if(this.meterRecordObj.type.billChargeType !== 'BY_MONTH'){
                return true
            }else{
                return false
            }
        },
        isAddInBill: function () {
            const list = this.meterRecordObj.utilityMeterList
            let addInBill = null
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.addInBill){
                    addInBill=i
                    break
                }
            }
            return addInBill
        },
        isImport: function () {
            if(
                this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT' && this.meterRecordObj.checkInMeter || 
                this.meterRecordObj.type && this.meterRecordObj.type.billChargeType === 'BY_KILOWATT' && this.meterRecordObj.utilityMeterList.length>1
            ){
                return true
            }else{
                return false
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        checkboxSingle
    }
}
</script>
<style lang="scss"  >
    #modal.import-meter-record{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 914px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                    padding: 0 45px;
                }
                .import-meter-record-wrap{
                    width: 849px;
                    padding: 0 32px 0 32px;
                    .content{
                        height: 500px;
                        overflow-x: hidden;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        >.no-result{
                            text-align: center;
                            margin-top: 186px;
                            >img{
                                margin-bottom: 20px;
                            }

                        }
                        .meter-record-block{
                            height: 54px;
                            padding: 0 40px;
                            font-size: 16px;
                            margin-bottom: 20px;
                            .prev-record{
                                width: 425px;
                                height: 100%;
                                border-right: 1px solid #f3f3f3;
                            }
                            .meter{
                                margin-left: 40px;
                            }
                            .amount{
                                margin-left: 8px;
                                font-size: 20px;
                            }
                            .no-result{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                        .list{
                            flex-wrap: wrap;
                            .item{
                                position: relative;
                                width: 270px;
                                border-radius: 6px;
                                border: solid 1px #f3f3f3;
                                background-color: #ffffff;
                                margin-bottom: 24px;
                                margin-right: 16px;
                                &:nth-child(3n){
                                    margin-right: 0px;
                                }
                                .image{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    position: relative;
                                    margin-bottom: 17px;
                                    width: 270px;
                                    height: 200px;
                                    overflow: hidden;
                                    border-radius: 4.4px;
                                    .meter-image{
                                        width: 270px;
                                    }
                                }
                                .item-meter{
                                    position: relative;
                                    margin-bottom: 11px;
                                    font-size: 20px;
                                    font-weight: 500;
                                    padding: 0 20px;
                                    >img{
                                        margin-right: 12px;
                                    }
                                    .checkbox-single{
                                        position: absolute;
                                        right: 20px;
                                    }
                                }
                                .group{
                                    height: 26px;
                                    padding: 0 20px;
                                    margin-bottom: 16px;
                                    justify-content: space-between;
                                    .status{
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border-radius: 1px;
                                        font-size: 12px;
                                        text-align: center;
                                        width: 84px;
                                        height: 26px;
                                        border-radius: 2px;
                                        line-height: 1.5;
                                        &.gray{
                                            background-color: #f3f3f3;
                                            color: #676362;
                                        }
                                        &.blue{
                                            background-color: rgba(113, 170, 229, 0.1);
                                            color: #71aae5;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/importMeterRecord.vue